import { TRACKING_URL } from '@/lib/constants';
import { parseAsColumnFilters } from '@/utils/nuqs/parse-as-column-filters';

export const getTrackingDetailUrl = (trackingNumber: string): string => {
  const filters = parseAsColumnFilters.serialize([{ id: 'shipmentId', value: trackingNumber }]);

  return `${TRACKING_URL}?filters=${filters}`;
};
